// Every word the player can read, in Russian.
//
// A translation of en.js and nothing else: the same keys in the same order, so the two files can
// be read side by side — and so a key added to the original is a key missing here, which is
// something a diff can see. i18n.js falls back to English for anything this file has not filled
// in, so a gap here shows English rather than a blank or a raw key name.

export default {
  // --- chrome --------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'Классика метания бананов, заново собранная и многопользовательская: пошаговая артиллерия над неоновым городом. Против ИИ, за одной клавиатурой или по коду. Бесплатно и на шести языках.',
  'app.tagline': 'Классическая игра в метание бананов — заново собранная и с мультиплеером.',
  'app.footer': 'Сделано Mendo Network, с любовью и большой ностальгией.',
  'ad.label': 'Реклама',
  'ad.tag': 'РЕКЛАМА',
  'app.canvasLabel': 'Поле боя: неоновый горизонт и два гориллы, которые бросают бананы',
  'app.language': 'ЯЗЫК',

  'title.start': '▶ ИГРАТЬ',
  'title.join': '▶ ПРИСОЕДИНИТЬСЯ',

  'menu.title': 'ГЛАВНОЕ МЕНЮ',
  'menu.resume': '▶ ВЕРНУТЬСЯ В ИГРУ',
  'menu.newMatch': '▶ НОВАЯ ИГРА',
  'menu.play': '▶ НОВАЯ ИГРА',
  'menu.characters': '🎨 ПЕРСОНАЖ',
  'menu.leaderboards': '🏆 ТАБЛИЦЫ',
  'menu.back': '← НАЗАД К НАЧАЛУ',
  'menu.awards': '🏆 НАГРАДЫ',

  'setup.title': 'НАСТРОЙКА ИГРЫ',
  'setup.mode': 'РЕЖИМ',
  'setup.players': 'ИГРОКИ',
  'setup.turn': 'ВРЕМЯ ХОДА',
  'setup.noLimit': 'БЕЗ ЛИМИТА',
  'setup.target': 'РАУНДЫ МАТЧА',
  'setup.onePlayer': '🤖 1 ИГРОК',
  'setup.twoPlayers': '👥 2 ИГРОКА',
  'setup.back': '← НАЗАД',
  'setup.start': '▶ НАЧАТЬ ИГРУ',

  'pause.title': 'ПАУЗА',
  'pause.turn': 'ХОД {name}',
  'pause.resume': '▶ ПРОДОЛЖИТЬ',
  'pause.restart': '↻ ЗАНОВО',
  'pause.setup': '🎮 НАСТРОЙКИ ИГРЫ',
  'pause.share': '🔗 ПРИГЛАСИТЬ',
  'pause.home': '🚪 ЗАВЕРШИТЬ ИГРУ',
  'pause.menu': '⌂ В ГЛАВНОЕ МЕНЮ',
  'pause.music': 'МУЗЫКА',
  'pause.fx': 'ЭФФЕКТЫ',
  'setup.against': 'ПРОТИВ КОГО',
  'setup.againstCpu': '🤖 ПРОТИВ КОМПЬЮТЕРА',
  'setup.againstRandom': '🎲 СЛУЧАЙНЫЙ СОПЕРНИК',
  'pool.waiting': '{n} ЖДУТ',
  'pool.playing': '{n} ИГРАЮТ · {w} ЖДУТ',
  'pool.none': 'СЕЙЧАС НИКТО НЕ ЖДЁТ',
  'pool.noserver': 'НЕТ СЕРВЕРА · ВЫ БУДЕТЕ ИГРАТЬ С КОМПЬЮТЕРОМ',
  'search.title': 'ПОИСК СОПЕРНИКА',
  'search.empty': 'ОЧЕРЕДЬ ПУСТА · ВЫ БУДЕТЕ ИГРАТЬ С КОМПЬЮТЕРОМ',
  'search.seconds': '{n} с',
  'search.matched': '{name} ПРИБЫЛ',
  'search.cpu': '🤖 ИГРАТЬ С КОМПЬЮТЕРОМ',
  'search.cancel': '✖ ОТМЕНА',
  'special.sheep.name': 'ОВЦА',
  'special.sheep.hint': 'Прыгает сама и взрывается.',
  'play.fireSheep': '🐑 ОВЦА!',
  'bubble.sheep': 'БЕЕЕ!',
  'char.you': 'ВЫ',
  'char.rival': 'СОПЕРНИК',
  'hud.vsOnline': 'ПРОТИВ {name}',
  'music.on': 'МУЗЫКА ВКЛ',
  'music.off': 'МУЗЫКА ВЫКЛ',
  'pause.button': 'Пауза',

  'results.over': 'ИГРА ОКОНЧЕНА',
  'results.wins': '{name} ПОБЕЖДАЕТ',
  'results.rematch': '▶ ЕЩЁ РАЗ',

  // --- the header and the play bar ----------------------------------------
  'hud.vsCpu': 'ПРОТИВ КОМПЬЮТЕРА',
  'hud.twoPlayer': '2 ИГРОКА',
  'hud.firstTo': 'ДО',
  'hud.round': 'РАУНД {n}',
  'hud.noRound': 'РАУНД —',
  'hud.p1': 'И1',
  'hud.p2': 'И2',
  'hud.cpu': 'КОМП',
  'hud.wind': 'ВЕТЕР',

  'play.angle': 'УГОЛ',
  'play.power': 'СИЛА',
  'play.fire': 'БРОСИТЬ',
  'play.waiting': 'ЖДЁМ ПРОТИВНИКА',
  'play.fireBall': 'БРОСИТЬ МЯЧ',
  'play.fireGrenade': 'БРОСИТЬ ГРАНАТУ',
  'play.fireLeap': 'ПРЫГНУТЬ И БРОСИТЬ',
  'play.fireShield': 'ПОДНЯТЬ ЩИТ',
  'play.fireSpring': 'ВСТАТЬ НА ПРУЖИНУ',
  'play.fireMushroom': 'ОСТАВИТЬ ГРИБ',

  // --- the special button --------------------------------------------------
  'special.none': '✦ ОСОБОЕ: НЕТ',
  'special.spent': '✦ ОСОБОЕ: ИЗРАСХОДОВАНО',
  'special.locked': '✦ ОСОБОЕ: ЗАКРЫТО',
  'special.off': 'БЕЗ ОСОБЫХ',
  'special.chosen': '✦ {name} × {n}',

  // --- panels --------------------------------------------------------------
  'loadout.title': '🎒 СНАРЯЖЕНИЕ',
  'loadout.note': 'То, что у вас с собой: выбранное определяет ваш следующий бросок, а защита ставится кнопкой щита. (Клавиша I открывает это.)',
  'intro.welcome': '{n} СПОСОБНОСТИ ГОТОВЫ — ⚔ АТАКА ВЫБИРАЕТ',
  'loadout.next': 'Оставлено на следующий ход.',
  'loadout.ults': 'ОСОБЫЕ АТАКИ',
  'loadout.guards': 'ЗАЩИТЫ',
  'loadout.howto': 'Награда: {name}',
  'loadout.off': 'В этом режиме нет особых атак и защит: CLASSIC — это оригинальная игра.',
  'special.attack': '⚔ АТАКА',
  'special.guard': '🛡 ЗАЩИТА',
  'announce.round': 'РАУНД {n}',
  'announce.fight': 'В БОЙ!',
  'announce.turn': 'ВАШ ХОД — {name}',
  'splash.tapForMusic': 'КОСНИТЕСЬ, ЧТОБЫ УСЛЫШАТЬ МУЗЫКУ',
  'char.title': '🎨 ПЕРСОНАЖИ',
  'char.close': '✕ ЗАКРЫТЬ',
  'char.save': '✓ СОХРАНИТЬ',
  'char.note': 'Вид и аксессуары. Зверь пошире — цель пошире, а цилиндр — голова чуть больше: картинка и есть зона попадания.',
  'char.player1': 'ИГРОК 1',
  'char.player2': 'ИГРОК 2',
  'slot.hat': 'ШАПКА',
  'slot.face': 'ЛИЦО',
  'slot.neck': 'ШЕЯ',

  'award.title': '🏆 НАГРАДЫ',
  'award.close': '✕ ЗАКРЫТЬ',
  'award.progress': '🏆 НАГРАДЫ {n}/{total}',
  'award.rewardAntic': '+ ЖЕСТ {name}',
  'award.rewardSpecial': '+ ОСОБОЕ {name}',

  'rank.title': '🏆 ТАБЛИЦЫ',
  'rank.close': '✕ ЗАКРЫТЬ',
  'rank.name': 'ВАШ НИК',
    'rank.namePlaceholder': 'Введи свой ник, чтобы играть',
  'rank.online': 'ОНЛАЙН — ЛУЧШИЕ СВЕРХУ',
  'rank.refresh': '↻ ОБНОВИТЬ',
  'rank.local': 'НА ЭТОМ УСТРОЙСТВЕ',
  'rank.emptyLocal': 'Пока пусто. Доиграйте партию, и она окажется здесь.',
  'rank.emptyOnline': 'На табло пока пусто. Будьте первым.',
  'rank.checking': 'Проверяем…',

  'share.close': 'ЗАКРЫТЬ',
  'share.generate': 'ПРИГЛАСИТЬ В ИГРУ',
  'share.placeholder': 'Здесь появится ваш код',
  'share.copied': 'Скопировано. Отправьте тому, кого хотите позвать.',
  'join.placeholder': 'У МЕНЯ ЕСТЬ КОД',
  'join.title': 'ПРИСОЕДИНИТЬСЯ К ИГРЕ',
  'join.label': 'Код игры',

  'lang.title': 'ЯЗЫК',
  'lang.note': 'Английский — оригинал. Всё остальное — перевод с него.',

  // --- shared match codes --------------------------------------------------
  'code.noCode': 'Сначала вставьте код.',
  'code.tooLong': 'Это слишком длинно для кода игры.',
  'code.notACode': 'На код игры это не похоже.',
  'code.version': 'Этот код из другой версии.',
  'code.corrupt': 'Повреждённый код.',
  'code.mode': 'В этом коде режим, которого в этой сборке нет.',

  // --- the shared board ----------------------------------------------------
  'lb.checking': 'спрашиваем сервер…',
  'lb.online': 'общая таблица, вживую',
  'lb.noServer': 'здесь нет сервера рейтинга',
  'lb.timeout': 'сервер не ответил вовремя',

  // --- what the gorillas shout --------------------------------------------
  'bubble.fireInTheHole': 'БЕРЕГИСЬ, ГРАНАТА!',
  'bubble.leap': 'ДОРОГУ!',
  'bubble.uavOnline': 'ВРАЖЕСКИЙ ДРОН В ВОЗДУХЕ',
  'bubble.headshot': 'БАБАХ, В ГОЛОВУ!',
  'bubble.extraLife': 'ЕЩЁ ЖИЗНЬ!',
  'bubble.mushroomSaved': 'ГРИБ ВЫДЕРЖАЛ!',
  'bubble.boomerangBack': 'ВЕРНУЛСЯ!',
  'bubble.boomerangLost': 'НЕ ВЕРНУЛСЯ',

  // --- the caption after a kill -------------------------------------------
  'wasted.subtitle': 'Ветру плевать на ваши планы.',

  // --- the sky -------------------------------------------------------------
  'banner.0': 'ЕШЬТЕ БОЛЬШЕ БАНАНОВ',
  'banner.1': 'ОБЕЗЬЯНСТВУЙ!',
  'banner.2': 'БАНАН В ПРЕЗИДЕНТЫ',
  'banner.3': 'ЭТОТ БАННЕР ВРАНЬЁ',
  'banner.4': 'ПРИШЛИТЕ БАНАНОВ',
  'banner.5': 'ОПЯТЬ МИМО',
  'banner.6': 'ОБНИМАШКИ БЕСПЛАТНО',
  'banner.7': 'СПАСИТЕ, Я В ИГРЕ',
  'banner.8': 'ВАЙС-СИТИ — 4 МИНУТЫ ПУТИ',
  'banner.9': 'ЛЕОНИДА: ДРУГАЯ ФЛОРИДА',
  'banner.10': 'ВЫЙДЕТ В 2027. НАВЕРНОЕ.',

  // --- the splash ----------------------------------------------------------
  'tip.0': 'СОВЕТ: ВЕТРУ ПЛЕВАТЬ НА ВАШИ ПЛАНЫ.',
  'tip.1': 'СОВЕТ: ПРИЦЕЛ НИКОГДА НЕ УЧИТЫВАЕТ ВЕТЕР. В ЭТОМ ВСЯ СУТЬ.',
  'tip.2': 'СОВЕТ: БАНАН, ВЕРНУВШИЙСЯ НАЗАД, ВСЁ ЕЩЁ БАНАН.',
  'tip.3': 'СОВЕТ: ГРАНАТЕ НЕ ОБЯЗАТЕЛЬНО В КОГО-ТО ПОПАДАТЬ.',
  'tip.4': 'СОВЕТ: ЕСЛИ ДРУГАЯ ГОРИЛЛА СПИТ — СТРЕЛЯЙ.',
  'tip.5': 'СОВЕТ: КТО-ТО ЖЕ ДОЛЖЕН УБРАТЬ ЭТОТ ГОРИЗОНТ.',

  // --- species -------------------------------------------------------------
  'species.gorilla': 'ГОРИЛЛА',
  'species.chimp': 'ШИМПАНЗЕ',
  'species.orangutan': 'ОРАНГУТАН',
  'species.baboon': 'ПАВИАН',
  'species.panda': 'ПАНДА',
  'species.bear': 'БУРЫЙ МЕДВЕДЬ',
  'species.rhino': 'НОСОРОГ',
  'species.bonobo': 'БОНОБО',
  'species.gibbon': 'ГИББОН',
  'species.mandrill': 'МАНДРИЛ',
  'species.hippo': 'БЕГЕМОТ',
  'species.duck': 'УТКА',
  'species.frog': 'ЛЯГУШКА',

  // --- accessories ---------------------------------------------------------
  'accessory.cap': 'КЕПКА',
  'accessory.beanie': 'ШАПКА',
  'accessory.tophat': 'ЦИЛИНДР',
  'accessory.crown': 'КОРОНА',
  'accessory.viking': 'ШЛЕМ ВИКИНГА',
  'accessory.bow': 'РОЗОВЫЙ БАНТ',
  'accessory.shades': 'ТЁМНЫЕ ОЧКИ',
  'accessory.patch': 'ПОВЯЗКА НА ГЛАЗ',
  'accessory.scarf': 'ШАРФ',
  'accessory.bowtie': 'БАБОЧКА',
  'accessory.chain': 'ЗОЛОТАЯ ЦЕПЬ',

  // --- gestures ------------------------------------------------------------
  'antic.scratch': 'ПОЧЕСАТЬСЯ',
  'antic.head': 'ЧЕСАТЬ ГОЛОВУ',
  'antic.chest': 'БИТЬ В ГРУДЬ',
  'antic.wave': 'ПОМАХАТЬ',
  'antic.pick': 'КОВЫРЯТЬ В НОСУ',
  'antic.shrug': 'ПОЖАТЬ ПЛЕЧАМИ',
  'antic.stretch': 'ПОТЯНУТЬСЯ',
  'antic.shake': 'ОТРЯХНУТЬСЯ',
  'antic.clap': 'АПЛОДИРУЕТ',
  'antic.flex': 'ПОКАЗЫВАЕТ МЫШЦЫ',

  // --- modes ---------------------------------------------------------------
  'mode.modern.name': 'СОВРЕМЕННЫЙ',
  'mode.modern.blurb': 'Особые приёмы, жесты, небо и награды.',
  'mode.classic.name': 'КЛАССИКА',
  'mode.classic.blurb': 'Ни особых приёмов, ни жестов, ни неба, ни наград.',
  'mode.demolition.name': 'СНОС',
  'mode.demolition.blurb': 'Воронки, от которых падает целая башня.',
  'mode.lunar.name': 'ЛУННАЯ ГРАВИТАЦИЯ',
  'mode.lunar.blurb': 'Треть притяжения.',
  'mode.weather.name': 'ПОГОДА',
  'mode.weather.blurb': 'Дождь, снег и порывы.',
  'mode.quake.name': 'ЗЕМЛЕТРЯСЕНИЕ',
  'mode.quake.blurb': 'Дома поднимаются и падают у вас под ногами.',

  // --- specials ------------------------------------------------------------
  'special.flare.name': 'РАКЕТА',
  'special.flare.hint': 'Прицел достаёт вдвое дальше.',
  'special.heavy.name': 'ТЯЖЁЛЫЙ',
  'special.heavy.hint': 'Ветер её почти не сносит.',
  'special.fat.name': 'ШИРОКИЙ',
  'special.fat.hint': 'Гораздо больше воронка.',
  'special.lunar.name': 'ЛУННЫЙ',
  'special.lunar.hint': 'Без ветра. Огромная воронка.',
  'special.grenade.name': 'ГРАНАТА',
  'special.grenade.hint': 'Скачет и взрывается по запалу.',
  'special.drone.name': 'ДРОН',
  'special.drone.hint': 'Пролетает и помечает их.',
  'special.leap.name': 'ПРЫЖОК',
  'special.leap.hint': 'Прыгает на место соперника.',
  'special.shield.name': 'ЩИТ',
  'special.shield.hint': 'Останавливает один выстрел соперника.',
  'social.title': 'РАССКАЖИТЕ КОМУ-НИБУДЬ',
  'social.whatsapp': 'Поделиться в WhatsApp',
  'social.telegram': 'Поделиться в Telegram',
  'social.facebook': 'Поделиться в Facebook',
  'social.x': 'Поделиться в X',
  'social.instagram': 'Отправить в Instagram — откроется меню отправки на телефоне',
  'social.copy': 'Скопировать ссылку',
  'toast.copied': '🔗 Ссылка скопирована',
  'toast.copyFailed': 'Браузер не разрешил скопировать',
  'special.pick': 'ВЫБЕРИТЕ ОДНО',
  'special.spring.name': 'ПРУЖИНА',
  'special.spring.hint': 'Встаньте на неё и пляшите.',
  'special.mushroom.name': 'ГРИБ',
  'special.mushroom.hint': 'Принимает удар, который вас убил бы.',

  'toast.crateSpecial': '📦 {name} +1 — и на следующий раунд ваш',
  'toast.crateTheirs': '📦 {who} забирает {name}',
  'toast.crateLife': '❤ ДОПЖИЗНЬ — выдержишь ещё один удар',
  'toast.crateLifeTheirs': '❤ {who} забирает дополнительную жизнь',
  'toast.award': '🏆 НАГРАДА! {names}',
  'setup.cpu': 'СЛОЖНОСТЬ КОМПЬЮТЕРА',
  'setup.cpuEasy': 'ЛЕГКО',
  'setup.cpuNormal': 'НОРМАЛЬНО',
  'setup.cpuHard': 'СЛОЖНО',
  'rotate.title': 'ПОВЕРНИТЕ ТЕЛЕФОН',
    'rotate.body': 'Игра идёт на боковом экране: поверните телефон на бок, чтобы продолжить.',
  'setup.duel': 'КАК ВЫ ИГРАЕТЕ ВДВОЁМ',
  'duel.code': '🔗 КАЖДЫЙ НА СВОЁМ ПК / ТЕЛЕФОНЕ',
  'duel.hotseat': '⌨️ ОДИН КОМПЬЮТЕР',
  'share.waiting': 'Отправьте им код. Они пришлют свой.',
  'share.invite': 'Скопируйте код и отправьте тому, кого хотите позвать.',
  'share.joined': 'Вы в игре. Бросаете первым.',
  'share.roomOpen': 'Комната открыта: этот код — дверь, игра идёт вживую, коды передавать не нужно.',
  'share.roomBack': 'Соперник зашёл.',
  'share.roomGone': 'Соперник вышел. Комната открыта, его место свободно.',
  'share.roomLost': 'Связь пропала. Партия продолжается на этом устройстве.',
  'code.inviteLength': 'В приглашении 8 символов, 4 и 4.',
  'code.inviteLetters': 'В этом коде есть символ, которого там быть не может.',
  'code.inviteCheck': 'Код не сходится: проверьте букву.',
  'special.ball.name': 'МЯЧ',
  'special.ball.hint': 'Иногда это мяч.',
  'special.boomerang.name': 'БУМЕРАНГ',
  'special.boomerang.hint': 'Возвращается в руку и не тратит заряд.',
  'toast.ball': '{icon} {name}!',
  'ball.basket': 'БАСКЕТБОЛЬНЫЙ МЯЧ',
  'ball.football': 'ФУТБОЛЬНЫЙ МЯЧ',
  'ball.rugby': 'МЯЧ ДЛЯ РЕГБИ',
  'ball.tennis': 'ТЕННИСНЫЙ МЯЧ',

  // --- achievements --------------------------------------------------------
  'ach.first-blood.name': 'ПЕРВАЯ КРОВЬ',
  'ach.first-blood.hint': 'Попадите первым бананом.',
  'ach.round-won.name': 'РАУНД ВЗЯТ',
  'ach.round-won.hint': 'Выиграйте раунд.',
  'ach.butterfingers.name': 'РУКИ-КРЮКИ',
  'ach.butterfingers.hint': 'Попасть в себя тоже считается.',
  'ach.sharpshooter.name': 'СНАЙПЕР',
  'ach.sharpshooter.hint': 'Попадите три раза подряд.',
  'ach.match-won.name': 'ИГРА ВЫИГРАНА',
  'ach.match-won.hint': 'Выиграйте партию.',
  'ach.cpu-slayer.name': 'ГРОЗА КОМПЬЮТЕРА',
  'ach.cpu-slayer.hint': 'Выиграйте партию у компьютера.',
  'ach.moon-shot.name': 'ЛУННЫЙ ВЫСТРЕЛ',
  'ach.moon-shot.hint': 'Проведите банан по диску луны.',
  'ach.sky-watcher.name': 'НАБЛЮДАТЕЛЬ',
  'ach.sky-watcher.hint': 'Увидьте три разные вещи в небе.',
  'ach.flawless.name': 'БЕЗ ЕДИНОЙ ОСЕЧКИ',
  'ach.flawless.hint': 'Выиграйте партию, не отдав ни одного раунда.',
  'ach.veteran.name': 'ВЕТЕРАН',
  'ach.veteran.hint': 'Выиграйте три партии.',
  'ach.thrower.name': 'МЕТАТЕЛЬ',
  'ach.thrower.hint': 'Бросьте 50 бананов.',
  'ach.rounds-10.name': 'ДЕСЯТЬ РАУНДОВ',
  'ach.rounds-10.hint': 'Выиграйте десять раундов.',
  'ach.sharpshooter-plus.name': 'ГЛАЗ-АЛМАЗ',
  'ach.sharpshooter-plus.hint': 'Попадите шесть раз подряд.',
  'ach.moon-3.name': 'АСТРОФИЗИК',
  'ach.moon-3.hint': 'Проведите банан по диску луны три раза.',
  'ach.cpu-3.name': 'В РАЖАРЕ',
  'ach.cpu-3.hint': 'Победите компьютер три раза.',
  'ach.flawless-3.name': 'НЕПРИКАСАЕМЫЙ',
  'ach.flawless-3.hint': 'Выиграйте три партии, не отдав ни одного раунда.',
  'ach.veteran-2.name': 'ЛЕГЕНДА',
  'ach.veteran-2.hint': 'Выиграйте пять партий.',
  'ach.scavenger.name': 'ПАДАЛЬЩИК',
  'ach.scavenger.hint': 'Разбейте пять ящиков.',
  'ach.wall.name': 'СТЕНА',
  'ach.wall.hint': 'Поднимите щит пять раз.',
  'ach.arsenal.name': 'АРСЕНАЛ',
  'ach.arsenal.hint': 'Используйте шесть разных приёмов.',
  'ach.bare-handed.name': 'ГОЛЫМИ РУКАМИ',
  'ach.bare-handed.hint': 'Победите, ничего не потратив.',
  'ach.room-won.name': 'В ЭФИРЕ',
  'ach.room-won.hint': 'Победите в партии в комнате.',
  'ach.room-3.name': 'СОСЕДИ',
  'ach.room-3.hint': 'Победите в трёх партиях в комнатах.',
  'ach.by-mail.name': 'ПО ПОЧТЕ',
  'ach.by-mail.hint': 'Победите в дуэли по коду.',
  'ach.boomerang-back.name': 'ВОЗВРАЩЕНИЕ',
  'ach.boomerang-back.hint': 'Поймайте свой бумеранг три раза.',
};
